export default __webpack_public_path__ + "static/media/qubiteq.7ddda2f8.png";